import { Input, Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTemplate]',
  standalone: true,
})
export class AppTemplateDirective {
  @Input() appTemplate: string | undefined;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.appTemplate!;
  }
}
